export default "__VITE_ASSET__BNUavBEL__"